import React, { FunctionComponent } from 'react'
import BaseModal from 'components/UI/BaseModal'
import Icon from 'components/UI/Icons'
import { Link } from 'react-router-dom'

interface Props {
    show: boolean
    close: any
}

const CreateApplicationModal: FunctionComponent<Props> = ({ show, close }) => {
    return (
        <BaseModal isVisible={show} close={close} className='w-11/12 sm:w-9/12 lg:w-7/12 xl:w-5/12 mx-auto'>
            <div className='mx-4 sm:mx-10 my-12'>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center'>
                        <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path
                                fillRule='evenodd'
                                clipRule='evenodd'
                                d='M10.4167 4.1665H39.5833C41.8845 4.1665 43.75 6.03198 43.75 8.33317V12.4998C43.75 14.801 41.8845 16.6665 39.5833 16.6665H10.4167C8.11548 16.6665 6.25 14.801 6.25 12.4998V8.33317C6.25 6.03198 8.11548 4.1665 10.4167 4.1665ZM22.9167 8.33317C21.7661 8.33317 20.8333 9.26591 20.8333 10.4165C20.8333 11.5671 21.7661 12.4998 22.9167 12.4998H33.3333C34.4839 12.4998 35.4167 11.5671 35.4167 10.4165C35.4167 9.26591 34.4839 8.33317 33.3333 8.33317H22.9167ZM14.5833 12.4998C15.7339 12.4998 16.6667 11.5671 16.6667 10.4165C16.6667 9.26591 15.7339 8.33317 14.5833 8.33317C13.4327 8.33317 12.5 9.26591 12.5 10.4165C12.5 11.5671 13.4327 12.4998 14.5833 12.4998Z'
                                fill='#52BD95'
                            />
                            <path
                                fillRule='evenodd'
                                clipRule='evenodd'
                                d='M10.4167 18.75H39.5833C41.8845 18.75 43.75 20.6155 43.75 22.9167V27.0833C43.75 29.3845 41.8845 31.25 39.5833 31.25H10.4167C8.11548 31.25 6.25 29.3845 6.25 27.0833V22.9167C6.25 20.6155 8.11548 18.75 10.4167 18.75ZM22.9167 22.9167C21.7661 22.9167 20.8333 23.8494 20.8333 25C20.8333 26.1506 21.7661 27.0833 22.9167 27.0833H33.3333C34.4839 27.0833 35.4167 26.1506 35.4167 25C35.4167 23.8494 34.4839 22.9167 33.3333 22.9167H22.9167ZM14.5833 27.0833C15.7339 27.0833 16.6667 26.1506 16.6667 25C16.6667 23.8494 15.7339 22.9167 14.5833 22.9167C13.4327 22.9167 12.5 23.8494 12.5 25C12.5 26.1506 13.4327 27.0833 14.5833 27.0833Z'
                                fill='#0D1537'
                            />
                            <path
                                fillRule='evenodd'
                                clipRule='evenodd'
                                d='M10.4167 33.3335H39.5833C41.8845 33.3335 43.75 35.199 43.75 37.5002V41.6668C43.75 43.968 41.8845 45.8335 39.5833 45.8335H10.4167C8.11548 45.8335 6.25 43.968 6.25 41.6668V37.5002C6.25 35.199 8.11548 33.3335 10.4167 33.3335ZM22.9167 37.5002C21.7661 37.5002 20.8333 38.4329 20.8333 39.5835C20.8333 40.7341 21.7661 41.6668 22.9167 41.6668H33.3333C34.4839 41.6668 35.4167 40.7341 35.4167 39.5835C35.4167 38.4329 34.4839 37.5002 33.3333 37.5002H22.9167ZM14.5833 41.6668C15.7339 41.6668 16.6667 40.7341 16.6667 39.5835C16.6667 38.4329 15.7339 37.5002 14.5833 37.5002C13.4327 37.5002 12.5 38.4329 12.5 39.5835C12.5 40.7341 13.4327 41.6668 14.5833 41.6668Z'
                                fill='#0D1537'
                            />
                        </svg>
                        <div className='ml-2'>
                            <p className='text-dark text-lg font-medium'>Create new application</p>
                            <p className='text-dark opacity-50 mt-2'>Date and time: Oct 11 - 10:30pm</p>
                        </div>
                    </div>
                    <button onClick={close} aria-label='close'>
                        <Icon name='cancel' className='w-4' />
                    </button>
                </div>
                <div className=' mt-10 mb-8'>
                    <hr className='border-t-2 border-snow-100' />
                </div>

                <div className='text-center'>
                    <p className='w-11/12 mx-auto tracking-wide text-sm leading-6'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quam suscipit magna viverra nec,
                        ullamcorper posuere.
                    </p>

                    <div className='mt-4'>
                        <button className='rounded-xs w-8/12 mx-auto bg-green text-sm font-medium text-white py-4'>
                            Create new application
                        </button>
                    </div>
                    <div className='mt-4'>
                        <Link to='/' className='text-blue-dark font-medium'>
                            Read terms and conditions
                        </Link>
                    </div>
                </div>
            </div>
        </BaseModal>
    )
}

export default CreateApplicationModal
